import React, { useState } from 'react';
import { Check, ShieldCheck, Flame, ArrowRight, Package, Clock, TrendingDown, BrainCog, AlertCircle, Star } from 'lucide-react';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
export function App() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'completo' | 'cognitivas20' | 'cognitivas60' | 'demencia' | 'demencialeve' | 'todo'>('todo');
  const checkoutUrlBase = 'https://psicocheck.librosdigitales.pro/cart/45964404621391:1';
  const checkoutUrlCompleto = 'https://terapeuticocheckout.ebookditales.com/cart/51868911468827:1';
  const checkoutUrlCognitivas20 = 'https://terapeuticocheckout.ebookditales.com/cart/51886382809371:1';
  const checkoutUrlCognitivas60 = 'https://terapeuticocheckout.ebookditales.com/cart/51886383726875:1';
  const checkoutUrlDemencia = 'https://terapeuticocheckout.ebookditales.com/cart/51886384415003:1';
  const checkoutUrlDemenciaLeve = 'https://terapeuticocheckout.ebookditales.com/cart/51886387364123:1';
  const checkoutUrlTodo = 'https://psicocheck.librosdigitales.pro/cart/45964460752975:1';
  const checkoutMap: Record<string, string> = {
    base: checkoutUrlBase,
    completo: checkoutUrlCompleto,
    cognitivas20: checkoutUrlCognitivas20,
    cognitivas60: checkoutUrlCognitivas60,
    demencia: checkoutUrlDemencia,
    demencialeve: checkoutUrlDemenciaLeve,
    todo: checkoutUrlTodo
  };
  const ctaTextMap: Record<string, string> = {
    base: 'SÍ, QUIERO MI MEGA PACK TERAPÉUTICO →',
    completo: 'SÍ, QUIERO MI MEGA PACK TERAPÉUTICO →',
    cognitivas20: 'SÍ, QUIERO MI MEGA PACK TERAPÉUTICO →',
    cognitivas60: 'SÍ, QUIERO MI MEGA PACK TERAPÉUTICO →',
    demencia: 'SÍ, QUIERO MI MEGA PACK TERAPÉUTICO →',
    demencialeve: 'SÍ, QUIERO MI MEGA PACK TERAPÉUTICO →',
    todo: 'SÍ, QUIERO MI MEGA PACK TERAPÉUTICO →'
  };
  const detailsMap: Record<string, {
    title: string;
    items: string[];
  }> = {
    base: {
      title: 'SISTEMA BASE INCLUYE:',
      items: ['✅ Tomo 1: El Salto Profesional', '✅ Tomo 2: La Primera Sesión', '✅ Tomo 3: Herramientas TCC (22 herramientas)', '✅ Tomo 4: Sistema TDAH (+120 fichas)', '✅ Tomo 5: Sistema Dislexia (72 actividades)', '✅ Tomo 6: El Semestre Resuelto (24 sesiones)', '✅ Bono 1: Kit Administrativo Anti-Cuelgue', '✅ Bono 2: Manual de Crisis', '✅ Bono 3: Mapa Terapéutico', '✅ Bono 4: Kit de Mensajes WhatsApp']
    },
    completo: {
      title: 'SISTEMA + ACTIVIDADES COGNITIVAS INCLUYE:',
      items: ['✅ Todo lo incluido en el Sistema Base', '✅ 50 actividades cognitivas para adolescentes']
    },
    cognitivas20: {
      title: 'SISTEMA + FICHAS COGNITIVAS 20-50 AÑOS INCLUYE:',
      items: ['✅ Todo lo incluido en el Sistema Base', '✅ Fichas cognitivas para adultos jóvenes y de mediana edad']
    },
    cognitivas60: {
      title: 'SISTEMA + EVALUACIÓN COGNITIVA 60-90 AÑOS INCLUYE:',
      items: ['✅ Todo lo incluido en el Sistema Base', '✅ Evaluación cognitiva especializada para adultos mayores']
    },
    demencia: {
      title: 'SISTEMA + DEMENCIA MODERADA INCLUYE:',
      items: ['✅ Todo lo incluido en el Sistema Base', '✅ Fichas de intervención en demencia moderada']
    },
    demencialeve: {
      title: 'SISTEMA + DEMENCIA LEVE INCLUYE:',
      items: ['✅ Todo lo incluido en el Sistema Base', '✅ Fichas cognitivas para demencia leve']
    },
    todo: {
      title: 'SISTEMA COMPLETO — TODO INCLUIDO:',
      items: ['✅ Tomo 1: El Salto Profesional', '✅ Tomo 2: La Primera Sesión', '✅ Tomo 3: Herramientas TCC (22 herramientas)', '✅ Tomo 4: Sistema TDAH (+120 fichas)', '✅ Tomo 5: Sistema Dislexia (72 actividades)', '✅ Tomo 6: El Semestre Resuelto (24 sesiones)', '✅ Los 4 Bonos profesionales', '✅ +60 plantillas imprimibles', '✅ 50 actividades cognitivas para adolescentes', '✅ Fichas cognitivas 20-50 años', '✅ Evaluación cognitiva 60-90 años', '✅ Fichas demencia moderada y leve', '✅ Acceso a TODO el material en un solo pago']
    }
  };
  return <div className="min-h-screen bg-gradient-to-b from-sky-50 via-white to-gray-50 font-sans text-gray-900" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      {/* Hero Section */}
      <header className="h-[100svh] md:h-auto md:py-16 px-3 py-3 bg-gradient-to-b from-sky-50 to-white flex flex-col md:block overflow-hidden" data-id="element-2">
        <div className="max-w-3xl mx-auto text-center w-full flex flex-col h-full md:h-auto md:block" data-id="element-3">
          <div className="bg-sky-100 rounded-xl px-4 py-1.5 md:px-6 md:py-3 mb-1.5 md:mb-3 max-w-2xl mx-auto flex-shrink-0" data-id="element-4">
            <p className="text-[9px] md:text-sm text-sky-800 leading-snug text-center" data-id="element-5">
              Para psicólogas que recién arrancan y sienten que saben atender...
              pero no saben cómo armar todo lo demás.
            </p>
          </div>

          <h1 className="text-xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-1.5 md:mb-4 px-1 flex-shrink-0" data-id="element-6">
            Recibiste el título.
            <span className="text-sky-600" data-id="element-7"> Pero nadie te dio el manual.</span>
          </h1>

          <p className="text-[10px] md:text-lg text-gray-800 font-medium mb-1 md:mb-2 max-w-2xl mx-auto px-1 leading-snug flex-shrink-0" data-id="element-8">
            Son las 11 de la noche. Mañana tenés pacientes. Y todavía no sabés
            qué vas a trabajar, cuánto cobrar ni qué le hacés firmar.
          </p>

          <p className="text-[10px] md:text-base text-sky-700 font-semibold mb-1 md:mb-2 max-w-2xl mx-auto px-1 leading-snug flex-shrink-0" data-id="element-9">
            Esto no es falta de capacidad. Es falta de sistema.
          </p>

          <p className="hidden md:block text-sm text-gray-500 italic mb-6 max-w-lg mx-auto" data-id="element-10">
            📄 100% PDF | ⚡ Acceso inmediato | 🇦🇷 Hecho para Argentina | ✅
            Listo para imprimir | 🧠 6 Tomos + 4 Bonos
          </p>

          <div className="flex-1 min-h-0 flex items-center justify-center md:flex-none md:mb-8 px-4 py-1" data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/o9rahMxwVzFokeA5voZERT/e7266c4c-3162-4d22-bf70-a5631664b650-removebg-preview.png" alt="Sistema Clínico 360™" className="max-w-full max-h-full w-auto h-auto md:w-full md:max-w-xl drop-shadow-2xl object-contain" data-id="element-12" />
          </div>

          <div className="mt-auto md:mt-0 flex-shrink-0" data-id="element-13">
            <div className="max-w-2xl mx-auto grid grid-cols-2 gap-x-3 gap-y-0.5 md:gap-x-6 md:gap-y-2 text-left px-2 mb-2 md:mb-8" data-id="element-14">
              {['Tomo 1: El Salto Profesional', 'Tomo 2: La Primera Sesión', 'Tomo 3: Herramientas TCC', 'Tomo 4: Sistema TDAH', 'Tomo 5: Sistema Dislexia', 'Tomo 6: El Semestre Resuelto', '4 Bonos Profesionales', '+60 Plantillas Imprimibles'].map((item, idx) => <div key={idx} className="flex items-center gap-1 md:gap-2" data-id="element-15">
                  <Check className="w-3 h-3 md:w-5 md:h-5 text-sky-600 flex-shrink-0" data-id="element-16" />
                  <span className="text-gray-700 text-[9px] md:text-sm leading-tight" data-id="element-17">
                    {item}
                  </span>
                </div>)}
            </div>

            <a href="#pricing" className="inline-flex items-center justify-center bg-sky-600 hover:bg-sky-700 text-white font-bold text-[12px] md:text-lg px-5 py-2.5 md:px-8 md:py-4 rounded-lg shadow-lg hover:shadow-xl transition-all hover:scale-105 mb-1" data-id="element-18">
              👉 Ver opciones desde $19.990
              <ArrowRight className="ml-1 w-3 h-3 md:w-5 md:h-5" data-id="element-19" />
            </a>
          </div>
        </div>
      </header>

      {/* Pain Point Section */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-20">
        <div className="max-w-3xl mx-auto" data-id="element-21">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-22">
            Probablemente esto te está pasando.
          </h2>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100 mb-8" data-id="element-23">
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-24">
              Terminás tu primera semana de consultorio.
            </p>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-25">Respirás.</p>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-26">
              Y te das cuenta de algo que nadie te avisó:
            </p>
            <p className="text-gray-800 font-medium mb-6 leading-relaxed" data-id="element-27">
              Saber atender no es lo mismo que saber cómo armar todo lo que
              rodea a una sesión.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-28">
              Porque en la facultad te enseñaron teoría, diagnóstico,
              intervención.
            </p>
            <p className="text-gray-700 mb-3" data-id="element-29">
              Pero el lunes a las 9 de la mañana, cuando entra tu primer
              paciente real, nadie te dijo:
            </p>
            <ul className="space-y-2 mb-6 ml-4" data-id="element-30">
              <li className="text-gray-600" data-id="element-31">
                Qué hacer exactamente en esos primeros 50 minutos.
              </li>
              <li className="text-gray-600" data-id="element-32">Qué formulario completar.</li>
              <li className="text-gray-600" data-id="element-33">
                Qué decir cuando te pregunta cuánto cobrás.
              </li>
              <li className="text-gray-600" data-id="element-34">Qué le hacés firmar.</li>
              <li className="text-gray-600" data-id="element-35">
                Cómo estructurás las sesiones siguientes para que haya un
                proceso real y no solo conversaciones sueltas.
              </li>
            </ul>
            <p className="text-gray-700 mb-3" data-id="element-36">
              Entonces hacés lo que hacemos todas al principio.
            </p>
            <p className="text-gray-700 font-medium mb-2" data-id="element-37">Improvisás.</p>
            <p className="text-gray-600 italic mb-6" data-id="element-38">
              Buscás fichas en internet a las 11 de la noche. Adaptás algo que
              encontraste en un grupo de WhatsApp. Imprimís sobre la marcha.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-39">
              Y entrás a la sesión con esa sensación en el pecho de:
            </p>
            <p className="text-sky-700 font-bold text-lg text-center mb-6 italic" data-id="element-40">
              "Espero que esto funcione."
            </p>
            <p className="text-gray-700 mb-4" data-id="element-41">Y no es solo la sesión.</p>
            <p className="text-gray-600 mb-3" data-id="element-42">
              También está la vergüenza de no saber bien cuánto cobrar y
              terminar poniendo un número al azar porque no querés parecer
              inexperta.
            </p>
            <p className="text-gray-600 mb-3" data-id="element-43">
              La incomodidad cuando un paciente te pregunta si hay algo para
              firmar y vos no tenés nada preparado.
            </p>
            <p className="text-gray-600 mb-3" data-id="element-44">
              El pánico cuando llega un caso de TDAH en tu segunda semana y los
              papás te miran esperando que hagas algo concreto.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-45">
              La angustia del domingo a la noche con las sesiones del lunes sin
              preparar y la sensación de que deberías saber más de lo que sabés.
            </p>
            <p className="text-gray-700 mb-3" data-id="element-46">
              Y la pregunta que aparece siempre, aunque no la digas en voz alta:
            </p>
            <p className="text-gray-800 font-medium text-center mb-6" data-id="element-47">
              ¿Por qué nadie me enseñó todo esto?
            </p>

            <div className="border-t border-gray-200 pt-6" data-id="element-48">
              <p className="text-gray-700 mb-2" data-id="element-49">
                La respuesta es simple y un poco injusta:
              </p>
              <p className="text-gray-800 font-medium mb-2" data-id="element-50">
                Porque la facultad te formó para entender la mente humana. No
                para sostener una práctica clínica real.
              </p>
              <p className="text-sky-600 font-semibold" data-id="element-51">
                Son dos cosas completamente distintas. Y esa brecha es
                exactamente lo que hace tan difícil el primer año.
              </p>
            </div>
          </div>

          <p className="text-center text-gray-700 mb-10" data-id="element-52">
            Porque cuando recién arrancás, no lidiás con un solo problema.
            Lidiás con cuatro al mismo tiempo.
          </p>

          <div className="space-y-6" data-id="element-53">
            <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-red-100 shadow-sm" data-id="element-54">
              <div className="flex items-center gap-3 mb-4" data-id="element-55">
                <div className="bg-red-100 p-2 rounded-full" data-id="element-56">
                  <AlertCircle className="w-6 h-6 text-red-500" data-id="element-57" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-58">
                  1️⃣ No sabés cómo estructurar el proceso terapéutico
                </h3>
              </div>
              <p className="text-gray-600 mb-3" data-id="element-59">
                Podés hacer una buena primera sesión.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-60">
                Pero ¿y la segunda? ¿Y la quinta? ¿Y cuando sentís que el
                proceso se estanca y no sabés para dónde ir?
              </p>
              <p className="text-gray-600 mb-3" data-id="element-61">
                Sin un sistema que te diga qué trabajar en cada etapa, cada
                semana es un invento nuevo.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-62">
                Y eso agota. Y genera esa sensación constante de que te falta
                algo.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-orange-100 shadow-sm" data-id="element-63">
              <div className="flex items-center gap-3 mb-4" data-id="element-64">
                <div className="bg-orange-100 p-2 rounded-full" data-id="element-65">
                  <BrainCog className="w-6 h-6 text-orange-500" data-id="element-66" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-67">
                  2️⃣ El caos administrativo del primer consultorio
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-68">
                ¿Necesito monotributo desde el primer paciente? ¿Cómo emito una
                factura? ¿Qué pasa si cancela a último momento? ¿Qué le cobro?
                ¿Hay algo que necesito que firme?
              </p>
              <p className="text-gray-600 mb-3" data-id="element-69">Nadie te lo explicó.</p>
              <p className="text-gray-700 font-medium" data-id="element-70">
                Y cada vez que aparece una de estas preguntas perdés tiempo,
                energía y tranquilidad que necesitás para atender bien.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-sky-100 shadow-sm" data-id="element-71">
              <div className="flex items-center gap-3 mb-4" data-id="element-72">
                <div className="bg-sky-100 p-2 rounded-full" data-id="element-73">
                  <TrendingDown className="w-6 h-6 text-sky-500" data-id="element-74" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-75">
                  3️⃣ Cobrás menos de lo que corresponde
                </h3>
              </div>
              <p className="text-gray-600 mb-3" data-id="element-76">
                Porque no sabés bien cuánto vale tu trabajo.
              </p>
              <p className="text-gray-600 mb-3" data-id="element-77">
                Porque te da vergüenza poner un número alto cuando recién
                empezás.
              </p>
              <p className="text-gray-600 mb-3" data-id="element-78">
                Porque nadie te enseñó a calcular un honorario que sea justo
                para vos y sostenible para tu consultorio.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-79">
                Entonces ponés lo que te parece razonable, que generalmente es
                menos de lo que deberías.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-purple-100 shadow-sm" data-id="element-80">
              <div className="flex items-center gap-3 mb-4" data-id="element-81">
                <div className="bg-purple-100 p-2 rounded-full" data-id="element-82">
                  <BrainCog className="w-6 h-6 text-purple-500" data-id="element-83" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-84">
                  4️⃣ La cabeza que no se apaga
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-85">
                Terminás el día y seguís pensando en las sesiones de mañana, en
                los materiales que faltan, en los casos que no sabés bien cómo
                manejar.
              </p>
              <p className="text-gray-600 mb-3" data-id="element-86">
                Porque arrancar sin un sistema es como construir una casa sin
                planos.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-87">
                Todo el tiempo sentís que algo puede fallar.
              </p>
            </div>
          </div>

          <div className="mt-10 text-center max-w-2xl mx-auto" data-id="element-88">
            <p className="text-gray-700 mb-3" data-id="element-89">
              Y lo más difícil de todo esto es que desde afuera parece que todas
              las demás tienen todo más claro que vos.
            </p>
            <p className="text-gray-600 mb-3" data-id="element-90">
              Que hay algo que ellas saben y vos todavía no aprendiste. Que es
              cuestión de tiempo y experiencia.
            </p>
            <p className="text-gray-800 font-medium mb-1" data-id="element-91">Pero no es eso.</p>
            <p className="text-sky-600 font-bold text-lg mb-6" data-id="element-92">
              Es cuestión de sistema.
            </p>
            <p className="text-gray-700 mb-2" data-id="element-93">
              Las psicólogas que arrancan con seguridad no saben más que vos.
            </p>
            <p className="text-gray-800 font-medium text-lg mb-2" data-id="element-94">
              Tienen más estructura.
            </p>
            <p className="text-sky-600 font-bold text-lg" data-id="element-95">
              Y esa estructura es exactamente lo que este sistema te da.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-12 md:py-16 px-4 bg-gradient-to-b from-sky-50 to-white" data-id="element-96">
        <div className="max-w-3xl mx-auto text-center" data-id="element-97">
          <span className="text-sky-600 font-bold text-sm uppercase tracking-wider" data-id="element-98">
            LA SOLUCIÓN
          </span>
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4" data-id="element-99">
            SISTEMA CLÍNICO 360™
          </h2>
          <p className="text-lg text-gray-600 mb-4" data-id="element-100">
            Todo lo que la facultad no te dio. En un solo sistema.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-101">
            No es teoría. No es un libro de texto.
          </p>
          <p className="text-gray-800 font-medium mb-8" data-id="element-102">
            Es un sistema de trabajo clínico completo, organizado, imprimible y
            listo para aplicar desde el momento en que lo descargás.
          </p>
          <p className="text-xl md:text-2xl font-bold text-sky-600 mb-8" data-id="element-103">
            Descargar. Imprimir. Aplicar.
          </p>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-104">
        <div className="max-w-3xl mx-auto" data-id="element-105">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-106">
            LOS 6 TOMOS
          </h2>

          <div className="space-y-6" data-id="element-107">
            <div className="bg-sky-50 rounded-2xl p-6 md:p-8 border-2 border-sky-200" data-id="element-108">
              <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-109">
                <span className="text-2xl" data-id="element-110">📚</span> TOMO 1: EL SALTO
                PROFESIONAL
              </h3>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-111">
                Lo que necesitás saber antes de atender tu primer paciente pago
              </p>
              <div className="grid md:grid-cols-2 gap-2 mb-4" data-id="element-112">
                {['Monotributo, AFIP y cómo emitir facturas', 'Cómo calcular tus honorarios con una fórmula concreta', 'Cómo hablar de plata sin incomodidad', 'Tu política de consultorio lista para imprimir', 'Cómo conseguir tus primeros pacientes'].map((item, idx) => <div key={idx} className="flex items-start gap-2 text-sm" data-id="element-113">
                    <Check className="w-4 h-4 text-sky-600 mt-0.5 flex-shrink-0" data-id="element-114" />
                    <span className="text-gray-700" data-id="element-115">{item}</span>
                  </div>)}
              </div>
              <p className="text-xs text-gray-500 font-medium" data-id="element-116">
                Incluye: Calculadora de Honorarios | Política de Consultorio A4
                | Plan de 30 días
              </p>
            </div>

            <div className="bg-sky-50 rounded-2xl p-6 md:p-8 border-2 border-sky-200" data-id="element-117">
              <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-118">
                <span className="text-2xl" data-id="element-119">📚</span> TOMO 2: LA PRIMERA SESIÓN
              </h3>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-120">
                El sistema completo para que el paciente sienta que llegó al
                lugar correcto
              </p>
              <div className="grid md:grid-cols-2 gap-2 mb-4" data-id="element-121">
                {['El guion completo de los primeros 50 minutos', 'Formulario de Anamnesis Estructurada (A4)', 'Cómo presentar el encuadre en lenguaje accesible', 'Cómo cerrar la primera sesión para asegurar el regreso'].map((item, idx) => <div key={idx} className="flex items-start gap-2 text-sm" data-id="element-122">
                    <Check className="w-4 h-4 text-sky-600 mt-0.5 flex-shrink-0" data-id="element-123" />
                    <span className="text-gray-700" data-id="element-124">{item}</span>
                  </div>)}
              </div>
              <p className="text-xs text-gray-500 font-medium" data-id="element-125">
                Incluye: Formulario de Anamnesis | Guía Rápida de Primera Sesión
                | Mensajes de WhatsApp profesionales
              </p>
            </div>

            <div className="bg-sky-50 rounded-2xl p-6 md:p-8 border-2 border-sky-200" data-id="element-126">
              <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-127">
                <span className="text-2xl" data-id="element-128">📚</span> TOMO 3: HERRAMIENTAS TCC
              </h3>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-129">
                22 herramientas clínicas con todos los registros listos para
                imprimir
              </p>
              <div className="space-y-2 mb-4" data-id="element-130">
                <p className="text-sm text-gray-700" data-id="element-131">
                  <span className="font-bold" data-id="element-132">PENSAMIENTOS:</span> RPA | RPR |
                  Flecha Descendente | Tribunal de Pensamientos | Creencias
                  Nucleares
                </p>
                <p className="text-sm text-gray-700" data-id="element-133">
                  <span className="font-bold" data-id="element-134">EMOCIONES:</span> Termómetro
                  Emocional | Respiración | Grounding | Exposición Gradual |
                  Validación Emocional
                </p>
                <p className="text-sm text-gray-700" data-id="element-135">
                  <span className="font-bold" data-id="element-136">CONDUCTA:</span> Activación
                  Conductual | Asertividad | Resolución de Problemas | Hábitos |
                  Registro de Logros
                </p>
              </div>
              <p className="text-xs text-gray-500 font-medium italic" data-id="element-137">
                Para esos momentos en sesión donde necesitás una intervención
                clara, ahora.
              </p>
            </div>

            <div className="bg-sky-50 rounded-2xl p-6 md:p-8 border-2 border-sky-200" data-id="element-138">
              <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-139">
                <span className="text-2xl" data-id="element-140">📚</span> TOMO 4: CLÍNICA INFANTIL —
                TDAH
              </h3>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-141">
                Para cuando llega un caso de TDAH y necesitás estructura sin
                improvisar
              </p>
              <div className="grid md:grid-cols-2 gap-2" data-id="element-142">
                {['24 sesiones estructuradas paso a paso', 'Banco de +120 fichas organizadas por área', 'Protocolo completo de primera reunión con padres', 'Modelo de Informe Escolar', 'Planilla de Evolución Mensual', 'Registro de Conducta en Casa para padres'].map((item, idx) => <div key={idx} className="flex items-start gap-2 text-sm" data-id="element-143">
                    <Check className="w-4 h-4 text-sky-600 mt-0.5 flex-shrink-0" data-id="element-144" />
                    <span className="text-gray-700" data-id="element-145">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="bg-sky-50 rounded-2xl p-6 md:p-8 border-2 border-sky-200" data-id="element-146">
              <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-147">
                <span className="text-2xl" data-id="element-148">📚</span> TOMO 5: APRENDIZAJE —
                DISLEXIA
              </h3>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-149">
                Sistema completo de intervención para dificultades de lectura y
                escritura
              </p>
              <div className="grid md:grid-cols-2 gap-2" data-id="element-150">
                {['Perfil Lector Inicial completo', '72 actividades graduadas por nivel', 'Conciencia fonológica | Fluidez | Comprensión | Escritura', 'Modelo de Informe Escolar con adecuaciones', 'Planilla de Lectura en Casa para padres', 'Gráfico de Progreso visual para motivar al niño'].map((item, idx) => <div key={idx} className="flex items-start gap-2 text-sm" data-id="element-151">
                    <Check className="w-4 h-4 text-sky-600 mt-0.5 flex-shrink-0" data-id="element-152" />
                    <span className="text-gray-700" data-id="element-153">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="bg-sky-50 rounded-2xl p-6 md:p-8 border-2 border-sky-200" data-id="element-154">
              <h3 className="font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-155">
                <span className="text-2xl" data-id="element-156">📚</span> TOMO 6: EL SEMESTRE
                RESUELTO
              </h3>
              <p className="text-gray-600 text-sm mb-4 italic" data-id="element-157">
                24 sesiones estructuradas para 6 meses de trabajo con adultos
              </p>
              <div className="grid md:grid-cols-2 gap-x-4 gap-y-2 mb-4" data-id="element-158">
                <p className="text-sm text-gray-700" data-id="element-159">
                  <span className="font-bold" data-id="element-160">BLOQUE 1 (Sesiones 1-4):</span>{' '}
                  Evaluación y Vínculo
                </p>
                <p className="text-sm text-gray-700" data-id="element-161">
                  <span className="font-bold" data-id="element-162">BLOQUE 2 (Sesiones 5-8):</span>{' '}
                  Psicoeducación y Primeras Herramientas
                </p>
                <p className="text-sm text-gray-700" data-id="element-163">
                  <span className="font-bold" data-id="element-164">BLOQUE 3 (Sesiones 9-12):</span>{' '}
                  Intervención Cognitiva
                </p>
                <p className="text-sm text-gray-700" data-id="element-165">
                  <span className="font-bold" data-id="element-166">BLOQUE 4 (Sesiones 13-16):</span>{' '}
                  Intervención Emocional
                </p>
                <p className="text-sm text-gray-700" data-id="element-167">
                  <span className="font-bold" data-id="element-168">BLOQUE 5 (Sesiones 17-20):</span>{' '}
                  Intervención Conductual
                </p>
                <p className="text-sm text-gray-700" data-id="element-169">
                  <span className="font-bold" data-id="element-170">BLOQUE 6 (Sesiones 21-24):</span>{' '}
                  Consolidación y Cierre
                </p>
              </div>
              <p className="text-sm text-gray-700 mb-2" data-id="element-171">
                <span className="font-bold" data-id="element-172">Cada sesión tiene:</span> objetivo
                claro | estructura de 50 minutos | intervenciones sugeridas |
                material de apoyo | tarea para el paciente | señales de progreso
              </p>
              <p className="text-xs text-gray-500 font-medium" data-id="element-173">
                Incluye: Hoja de Objetivos Terapéuticos | Plan de Mantenimiento
                Post-Proceso
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-174">
        <div className="max-w-4xl mx-auto" data-id="element-175">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-10" data-id="element-176">
            🎁 4 BONOS INCLUIDOS
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-177">
            {[{
            title: 'BONO 1: KIT ADMINISTRATIVO ANTI-CUELGUE',
            desc: 'Los documentos que necesitás listos para usar desde el primer día',
            items: ['Consentimiento Informado (A4)', 'Historia Clínica Semanal', 'Planilla de Gestión de Cobros', 'Contrato de Servicios Profesionales', 'Reglamento Interno del Consultorio'],
            image: 'https://cdn.magicpatterns.com/uploads/obAEEpvd6vHozr1QqmwEX5/bd5c6092-88ab-489c-9236-46a018f51221-removebg-preview.png'
          }, {
            title: 'BONO 2: MANUAL DE CRISIS',
            desc: 'Para esos momentos en sesión donde necesitás saber exactamente qué hacer, sin dudar',
            items: ['Protocolo de evaluación de riesgo suicida', 'Técnicas de Grounding para ataques de pánico en sesión', 'Guion de contención en crisis aguda', 'Números de emergencia y derivación inmediata'],
            image: 'https://cdn.magicpatterns.com/uploads/vMxGLEQ7TZhtHThDLdqQZH/751e3a26-32ae-4a1b-9b56-857abd2404d8-removebg-preview.png'
          }, {
            title: 'BONO 3: MAPA TERAPÉUTICO',
            desc: 'Un mapa visual que organiza todo el proceso terapéutico para que nunca pierdas el norte',
            items: [],
            image: 'https://cdn.magicpatterns.com/uploads/vMxGLEQ7TZhtHThDLdqQZH/751e3a26-32ae-4a1b-9b56-857abd2404d8-removebg-preview.png'
          }, {
            title: 'BONO 4: KIT DE MENSAJES WHATSAPP',
            desc: '21 mensajes listos para usar entre sesiones',
            items: ['Recordatorios de turno', 'Mensajes anti-ansiedad', 'Refuerzo del proceso terapéutico', 'Actualización de honorarios'],
            image: 'https://cdn.magicpatterns.com/uploads/sSPogfVhD5Rdym6Sndx6Q4/99c0d622-16f3-40ee-8dab-0de55f0d054d-removebg-preview.png'
          }].map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm" data-id="element-178">
                <div className="bg-gradient-to-br from-sky-50 to-sky-100 p-4 flex items-center justify-center" data-id="element-179">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-40 object-contain drop-shadow-lg" data-id="element-180" />
                </div>
                <div className="p-5" data-id="element-181">
                  <h3 className="font-bold text-gray-900 mb-2 text-sm" data-id="element-182">
                    🎁 {bonus.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3" data-id="element-183">{bonus.desc}</p>
                  {bonus.items.length > 0 && <ul className="space-y-1" data-id="element-184">
                      {bonus.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-xs text-gray-700" data-id="element-185">
                          <Check className="w-3 h-3 text-green-500 mt-0.5 flex-shrink-0" data-id="element-186" />
                          {item}
                        </li>)}
                    </ul>}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="py-12 md:py-16 px-4 bg-sky-50" data-id="element-187">
        <div className="max-w-4xl mx-auto" data-id="element-188">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-10" data-id="element-189">
            LO QUE DICEN COLEGAS QUE YA LO USAN
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-190">
            {[{
            text: 'Llegaba a las sesiones corriendo y sin tiempo. Ahora tengo todo armado. Atiendo más tranquila y mis pacientes lo notan.',
            name: 'Carla M.',
            role: 'Psicóloga Clínica'
          }, {
            text: 'Las 24 sesiones listas me ahorraron horas cada semana. Por primera vez siento que tengo un sistema real.',
            name: 'Lucía R.',
            role: 'TCC'
          }, {
            text: 'El material de TDAH me salvó. Llegó un caso complejo y ya tenía las fichas y la estructura lista. Pude enfocarme en el paciente.',
            name: 'Sofía P.',
            role: 'Psicóloga Infantojuvenil'
          }, {
            text: 'No es un PDF suelto. Es un sistema pensado para sostener procesos reales. El Tomo 1 me ayudó a armar el consultorio. El Tomo 2 me dio seguridad en las primeras sesiones.',
            name: 'Valentina G.',
            role: 'Psicóloga Clínica'
          }, {
            text: 'Estaba agotada de buscar en internet. Este sistema tiene todo organizado y listo para imprimir. Vale cada centavo.',
            name: 'María V.',
            role: 'Psicóloga de Adultos'
          }].map((testimonial, idx) => <div key={idx} className="bg-sky-50 p-6 rounded-2xl border border-sky-100" data-id="element-191">
                <div className="flex items-center gap-1 mb-3" data-id="element-192">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-193" />)}
                </div>
                <p className="text-gray-700 mb-4 italic text-sm leading-relaxed" data-id="element-194">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-195">
                  <div className="w-10 h-10 rounded-full bg-sky-200 flex items-center justify-center text-sky-700 font-bold text-sm" data-id="element-196">
                    {testimonial.name[0]}
                  </div>
                  <div data-id="element-197">
                    <p className="font-bold text-gray-900 text-sm" data-id="element-198">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-199">{testimonial.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-12 md:py-16 px-4 bg-white" data-id="element-200">
        <div className="max-w-2xl mx-auto" data-id="element-201">
          <p className="text-center text-slate-500 text-sm font-medium tracking-wider mb-4" data-id="element-202">
            ESTA OFERTA EXPIRA EN:
          </p>
          <div className="flex justify-center mb-8" data-id="element-203">
            <div className="bg-sky-50 border border-sky-200 rounded-full px-6 py-3 flex items-center gap-3 shadow-sm" data-id="element-204">
              <Clock className="w-5 h-5 text-sky-600" data-id="element-205" />
              <CountdownTimer initialMinutes={15} data-id="element-206" />
            </div>
          </div>
          <p className="text-center text-gray-500 text-sm mb-8" data-id="element-207">
            Después sube de precio y no vuelve a bajar.
          </p>

          <h2 className="text-2xl md:text-4xl font-extrabold text-slate-800 text-center mb-2" data-id="element-208">
            ELEGÍ TU SISTEMA CLÍNICO 360™
          </h2>
          <p className="text-center text-gray-500 text-sm md:text-base mb-8" data-id="element-209">
            Todas las opciones incluyen los 4 bonos completos
          </p>

          <div className="space-y-3 mb-8" data-id="element-210">
            {[{
            id: 'base',
            icon: '📦',
            title: 'SISTEMA BASE',
            desc: '6 Tomos + 4 Bonos + Todo el material clínico',
            oldPrice: '$79.000',
            price: '$19.990',
            badge: null
          }, {
            id: 'todo',
            icon: '⭐',
            title: 'SISTEMA COMPLETO — TODO INCLUIDO',
            desc: 'Todos los tomos, bonos y fichas cognitivas en un solo acceso',
            oldPrice: '$199.000',
            price: '$34.990',
            badge: 'MEJOR VALOR'
          }].map(option => <div key={option.id} onClick={() => setSelectedPlan(option.id as any)} className={`relative cursor-pointer rounded-2xl p-4 md:p-5 border-2 transition-all ${selectedPlan === option.id ? 'border-sky-500 bg-sky-50 shadow-md' : 'border-gray-200 bg-white hover:border-sky-300'}`} data-id="element-211">
                <div className="flex items-start gap-3" data-id="element-212">
                  <div className="mt-1 flex-shrink-0" data-id="element-213">
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === option.id ? 'border-sky-500' : 'border-gray-300'}`} data-id="element-214">
                      {selectedPlan === option.id && <div className="w-2.5 h-2.5 rounded-full bg-sky-500" data-id="element-215" />}
                    </div>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-216">
                    <div className="flex justify-between items-start gap-2" data-id="element-217">
                      <div className="flex-1 min-w-0" data-id="element-218">
                        <div className="flex items-center gap-1.5 flex-wrap mb-0.5" data-id="element-219">
                          <span className="text-base" data-id="element-220">{option.icon}</span>
                          <h3 className="font-bold text-slate-800 text-sm leading-tight" data-id="element-221">
                            {option.title}
                          </h3>
                        </div>
                        {option.badge && <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 text-xs font-bold px-2 py-0.5 rounded-full mb-1" data-id="element-222">
                            <Star className="w-3 h-3 fill-green-700" data-id="element-223" />{' '}
                            {option.badge}
                          </span>}
                        <p className="text-gray-500 text-xs leading-snug" data-id="element-224">
                          {option.desc}
                        </p>
                      </div>
                      <div className="text-right flex-shrink-0" data-id="element-225">
                        <p className="text-gray-400 line-through text-xs" data-id="element-226">
                          {option.oldPrice}
                        </p>
                        <p className={`font-extrabold ${option.id === 'todo' ? 'text-xl text-sky-600' : 'text-lg text-slate-800'}`} data-id="element-227">
                          {option.price}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          <a href={checkoutMap[selectedPlan]} className="block w-full bg-sky-600 hover:bg-sky-700 text-white font-bold text-lg md:text-xl px-8 py-5 rounded-lg shadow-xl transition-all hover:scale-105 text-center mb-4" data-id="element-228">
            {ctaTextMap[selectedPlan]}
          </a>

          <p className="text-center text-gray-500 text-sm mb-6" data-id="element-229">
            Podés cambiar de opción cuando quieras
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500 mb-8" data-id="element-230">
            <span data-id="element-231">✔ pago único</span>
            <span data-id="element-232">✔ acceso inmediato</span>
            <span data-id="element-233">✔ descarga ilimitada</span>
            <span data-id="element-234">✔ sin suscripciones</span>
          </div>

          {/* Details Box */}
          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8" data-id="element-235">
            <p className="text-slate-500 text-sm font-bold tracking-wider mb-6 uppercase" data-id="element-236">
              {detailsMap[selectedPlan].title}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-237">
              {detailsMap[selectedPlan].items.map((item, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-238">
                  <Check className="w-5 h-5 text-sky-500 mt-0.5 flex-shrink-0" data-id="element-239" />
                  <span className="text-gray-700 text-sm" data-id="element-240">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-12 md:py-16 px-4 bg-sky-50" data-id="element-241">
        <div className="max-w-2xl mx-auto text-center" data-id="element-242">
          <div className="bg-white border-2 border-green-200 rounded-2xl p-8 shadow-sm" data-id="element-243">
            <ShieldCheck className="w-16 h-16 text-green-600 mx-auto mb-4" data-id="element-244" />
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-245">
              🛡️ GARANTÍA TOTAL 7 DÍAS
            </h2>
            <p className="text-gray-700 mb-4 font-medium" data-id="element-246">
              Descargás. Revisás. Usás.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-247">
              Si en 7 días no sentís más orden, menos estrés y más seguridad en
              sesión, te devolvemos el 100% del dinero.
            </p>
            <p className="text-green-700 font-bold" data-id="element-248">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>
        </div>
      </section>

      {/* Closing Section */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-249">
        <div className="max-w-3xl mx-auto" data-id="element-250">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-251">
            UNA ÚLTIMA COSA
          </h2>
          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100 mb-8" data-id="element-252">
            <p className="text-gray-700 mb-4" data-id="element-253">
              Cuando arrancás un consultorio, hay dos caminos.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-254">
              <span className="font-bold" data-id="element-255">El primero</span> es el que toma la
              mayoría: improvisar semana a semana, buscar en internet a las 11
              de la noche, entrar a las sesiones con esa sensación de que algo
              falta, cobrar menos de lo que corresponde porque nadie te enseñó a
              poner un precio.
            </p>
            <p className="text-gray-800 font-bold mb-4" data-id="element-256">
              El segundo es tener un sistema desde el primer día.
            </p>
            <ul className="space-y-2 mb-6 ml-4" data-id="element-257">
              <li className="text-gray-700" data-id="element-258">
                • Un sistema que ya tiene el formulario de anamnesis listo.
              </li>
              <li className="text-gray-700" data-id="element-259">
                • Que tiene el guion de la primera sesión escrito.
              </li>
              <li className="text-gray-700" data-id="element-260">
                • Que tiene las fichas de TDAH organizadas.
              </li>
              <li className="text-gray-700" data-id="element-261">
                • Que tiene las 24 sesiones estructuradas para que nunca más
                entres sin saber qué trabajar.
              </li>
              <li className="text-gray-700" data-id="element-262">
                • Que tiene el contrato, la política de consultorio y la
                planilla de cobros.
              </li>
            </ul>
            <p className="text-gray-800 font-medium mb-6" data-id="element-263">
              Todo en un lugar. Todo listo. Todo imprimible.
            </p>
            <div className="border-t border-gray-200 pt-6 text-center" data-id="element-264">
              <p className="text-gray-700 mb-2" data-id="element-265">
                El Sistema Clínico 360™ no te hace mejor psicóloga.
              </p>
              <p className="text-gray-800 font-bold mb-2" data-id="element-266">
                Vos ya sos buena psicóloga.
              </p>
              <p className="text-sky-600 font-semibold" data-id="element-267">
                Lo que hace es darte la estructura para que eso se note.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-268">
            <a href="#pricing" className="inline-block w-full md:w-auto bg-sky-600 hover:bg-sky-700 text-white font-bold text-lg md:text-xl px-8 py-5 rounded-lg shadow-xl transition-all hover:scale-105 mb-4" data-id="element-269">
              → SÍ, QUIERO MI MEGA PACK TERAPÉUTICO
            </a>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-270">
              <span data-id="element-271">✔ Pago único</span>
              <span data-id="element-272">✔ Acceso inmediato</span>
              <span data-id="element-273">✔ Garantía 7 días</span>
              <span data-id="element-274">✔ Sin suscripciones</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm" data-id="element-275">
        <p className="mb-4" data-id="element-276">
          © 2025 Sistema Clínico 360™ — Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4" data-id="element-277">
          <a href="#" className="hover:text-white" data-id="element-278">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white" data-id="element-279">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white" data-id="element-280">
            Contacto
          </a>
        </div>
      </footer>
    </div>;
}